import {css} from '@emotion/react'
import {colors, gethomeLink} from '../../../constants'
import StartpageLogo from '../../../images/startpage-logo-new.svg'
import StartpageBrowserLogo from '../../../images/browser/startpage-browser-logo.svg'
import {useOnce} from '../../../util/customHooks'
import {EVENTS, logDplWithExtensionParams} from '../../../util/dpl'
import Inter from '../../../fonts/Inter'
import Email from './Email'
import {getCountry} from '../../../util/getCountry'

const UnSupported = ({os, browser, experimentId}) => {
    useOnce(() => {
        logDplWithExtensionParams(EVENTS.StartpageBrowserUnupportedVisit, {
            experiment: experimentId,
            os,
            browser,
            country: getCountry(),
        })
    })
    return (
        <div
            className="unsupported"
            css={css`
                ${Inter};
                font-family: Inter, sans-serif;
                max-width: 966px;
                margin: 0 auto;
                padding: 0 2rem;
                color: ${colors.midnight};
            `}
        >
            <a
                href={gethomeLink()}
                target="__blank"
                rel="noopener noreferrer nofollow"
                className="logo"
                css={css`
                    display: block;
                    margin: 44px 0;
                `}
            >
                <StartpageLogo />
            </a>
            <div
                className="content"
                css={css`
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                `}
            >
                <div
                    className="text"
                    css={css`
                        background: ${colors.whisperDark};
                        text-align: center;
                        padding: 130px;
                        border-radius: 10px;
                        @media (max-width: 800px) {
                            padding: 2rem;
                        }
                        h1 {
                            font-weight: 800;
                        }
                        p {
                            line-height: 24px;
                        }
                    `}
                >
                    <h1>Unable to install.</h1>
                    <p>
                        Your operating system is not supported at this time. Startpage’s desktop browsing app is
                        currently available for Mac and Windows only.{' '}
                    </p>

                    <p>Enter your email below to be alerted when Startpage for Linux is released.</p>
                </div>
                <div
                    className="widget"
                    css={css`
                        display: flex;
                        align-items: center;
                        margin: 80px auto 0;
                        @media (max-width: 800px) {
                            flex-direction: column;
                            margin: 2rem 0;
                        }
                    `}
                >
                    <StartpageBrowserLogo />
                    <div
                        className="email"
                        css={css`
                            margin: 0 0 0 30px;
                            max-width: 291px;
                            p {
                                line-height: 24px;
                            }
                            @media (max-width: 800px) {
                                margin: 0;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                h2 {
                                    margin: 1rem 0 0;
                                }
                            }
                        `}
                    >
                        <h2>Alert me!</h2>
                        <p>Sign up to receive early access to new products and Startpage news.</p>
                        <Email />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UnSupported
